import { createStore, Store } from 'redux';
import { REFERRAL_URL_TYPE } from '../constants';
import { AppStoreAction } from './AppStore';
import { AuthStoreAction } from './AuthStore';
import { ActionType, StoreStateInternal } from './StoreTypes';

export type StoreType = Store<StoreStateInternal>;
export type StoreAction = AuthStoreAction | AppStoreAction;

export const INITIAL_STATE: StoreStateInternal = {
  user: undefined,
  firebaseUser: undefined,
  userStatus: { firstTimeVisit: false },
  authenticatingExistingMindsetId: false,
  hcpReferralHash: undefined,
  referralUrlType: REFERRAL_URL_TYPE.LINK,
};

export function reducer(
  state: StoreStateInternal = INITIAL_STATE,
  action: StoreAction
): StoreStateInternal {
  switch (action.type) {
    case ActionType.SET_USER:
      return { ...state, user: action.user };

    case ActionType.SET_FIREBASE_USER:
      return { ...state, firebaseUser: action.firebaseUser };

    case ActionType.SET_USER_STATUS:
      return { ...state, userStatus: action.userStatus };

    case ActionType.SET_AUTHENTICATING_EXISTING_MINDSET_ID:
      return {
        ...state,
        authenticatingExistingMindsetId: action.authenticatingExistingMindsetId,
      };

    case ActionType.SET_HCP_PATIENT_LINK_ID:
      return { ...state, hcpReferralHash: action.hcpReferralHash };

    case ActionType.CLEAR_USER:
      return { ...state, user: undefined };

    case ActionType.SET_REFERRAL_URL_TYPE:
      return { ...state, referralUrlType: action.referralUrlType };

    default:
      return state;
  }
}
/**
 * Enable store access for the Redux Dev Tools Chrome Extenions
 *  See https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd/related
 */
function enableReduxDevTools() {
  return (
    // eslint-disable-next-line
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
  );
}

export const store = createStore(reducer, enableReduxDevTools());
